import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsConfig, ConfigModule } from '@spartacus/core';
import { PAGE_LAYOUT_HANDLER } from '@spartacus/storefront';
import { KnBrSalesCheckoutComponent } from './kn-br-sales-checkout/kn-br-sales-checkout.component';
import { KnBrCustomerContextGuard } from '../shared/guards/kn-br-customer-context.guard';
import { SalesCheckoutPageLayoutHandler } from './sales-checkout-page-layout.handler';

@NgModule({
  declarations: [],
  imports: [CommonModule,
    ConfigModule.withConfig({
            cmsComponents: {
                CheckoutSalesAddressComponent: {
                    component: KnBrSalesCheckoutComponent,
                    guards:[KnBrCustomerContextGuard]
                }
            },
        } as CmsConfig),
        KnBrSalesCheckoutComponent,
  ],
  providers: [
    {
      provide: PAGE_LAYOUT_HANDLER,
      useExisting: SalesCheckoutPageLayoutHandler,
      multi: true,
    },
  ],
})
export class KnBrSalesCheckoutModule {}
